import { isTypeTestimonialSection } from '@platform/contentful';
import { Entry } from 'contentful';
import Divider from './util/Divider';
import ContentfulTestimonial from './ContentfulTestimonial';

const ContentfulTestimonialSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeTestimonialSection(entry)) {
    return null;
  }

  return (
    <div className='flex flex-col items-center mb-8'>
      <h1 className='text-center font-header text-4xl sm:text-5xl leading-11 sm:leading-14 font-bold text-gray-500'>
        {entry.fields.header}
      </h1>
      <Divider />
      {entry.fields.testimonials && (
        <div className='mt-8 flex flex-col sm:flex-row gap-12 sm:gap-4'>
          {entry.fields.testimonials?.map((testimonial, index) => (
            <ContentfulTestimonial key={index} entry={testimonial} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentfulTestimonialSection;
